<div class="card w-full h-full flex flex-col shadow-sm p-6 rounded-2xl bg-white gap-8">
  <div class="flex flex-col">
    <h1 class="font-semibold text-2xl">Gestión de Ventas</h1>
    <p class="text-secondary-500">
      Consulta general de pedidos confirmados. Utiliza el buscador para filtrar la información.
    </p>
  </div>

  <div class="flex flex-row flex-wrap justify-start gap-4 items-end">

    <div class="flex flex-col gap-1 relative z-30">
      <label class="text-xs font-semibold text-gray-600">Asesor Comercial</label>
      <input type="text" [(ngModel)]="filters.asesor"
        (input)="onSearchInput('asesor')"
        (focus)="onFocus('asesor')"
        (blur)="onBlur('asesor')"
        placeholder="Buscar asesor..."
        autocomplete="off"
             [disabled]="flowFromBodega || flowFromCliente"
        class="block w-70 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 hover:bg-secondary-75/50 focus:outline-none text-gray-800" />

      @if (showDropdown.asesor && suggestions.asesor.length > 0) {
        <ul class="absolute z-40 w-full bg-white border border-gray-300 top-full mt-1 shadow-lg max-h-40 overflow-auto rounded-md">
          @for (item of suggestions.asesor; track item.an) {
            <li (click)="selectSuggestion('asesor', item)" class="p-2 hover:bg-orange-100 cursor-pointer text-sm">
              {{ item.name }} ({{ item.an }})
            </li>
          }
        </ul>
      }
    </div>

    <div class="flex flex-col gap-1 relative z-20">
      <label class="text-xs font-semibold text-gray-600">Cliente</label>
      <input type="text" [(ngModel)]="filters.cliente"
        (input)="onSearchInput('cliente')"
        (focus)="onFocus('cliente')"
        (blur)="onBlur('cliente')"
        placeholder="Buscar cliente..."
        autocomplete="off"
        [disabled]="flowFromBodega"
        class="block w-80 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 hover:bg-secondary-75/50 focus:outline-none text-gray-800" />

      @if (showDropdown.cliente && suggestions.cliente.length > 0) {
        <ul class="absolute z-40 w-full bg-white border border-gray-300 top-full mt-1 shadow-lg max-h-40 overflow-auto rounded-md">
          @for (item of suggestions.cliente; track item.an) {
            <li (click)="selectSuggestion('cliente', item)" class="p-2 hover:bg-orange-100 cursor-pointer text-sm">
              {{ item.name }} ({{ item.an }})
            </li>
          }
        </ul>
      }
    </div>

    <div class="flex flex-col gap-1 relative z-10">
      <label class="text-xs font-semibold text-gray-600">Bodega</label>
      <input
        type="text"
        [(ngModel)]="filters.bodega"
        (input)="onSearchInput('bodega')"
        (focus)="onFocus('bodega')"
        (blur)="onBlur('bodega')"
        placeholder="Buscar bodega..."
        autocomplete="off"
        [disabled]="flowFromAsesor && !selectedValues.clienteAN"
        class="block w-50 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 hover:bg-secondary-75/50 focus:outline-none text-gray-800"
      />

      @if (showDropdown.bodega && suggestions.bodega.length > 0) {
        <ul class="absolute z-40 w-full bg-white border border-gray-300 top-full mt-1 shadow-lg max-h-40 overflow-auto rounded-md">
          @for (item of suggestions.bodega; track item.id) {
            <li (click)="selectSuggestion('bodega', item)" class="p-2 hover:bg-orange-100 cursor-pointer text-sm">
              {{ item.name }} ({{ item.code }})
            </li>
          }
        </ul>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-xs font-semibold text-gray-600">Fecha desde</label>
      <input
        type="date"
        [(ngModel)]="filters.fechaDesde"
        (change)="onDateChange()"
        class="block w-45 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 focus:outline-none text-gray-800"
      />
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-xs font-semibold text-gray-600">Fecha hasta</label>
      <input
        type="date"
        [(ngModel)]="filters.fechaHasta"
        (change)="onDateChange()"
        class="block w-45 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 focus:outline-none text-gray-800"
      />
    </div>

    <div class="flex gap-2 mb-0.5">
      <app-button label="Limpiar filtros" color="red-500" icon="fi-rr-eraser" (click)="cleanFilter()"></app-button>
    </div>

  </div>

  <div class="overflow-x-auto">
    @if (salesList && salesList.length > 0) {
    <div class="card">
      <p-table [value]="salesList" [paginator]="true" [rows]="rows" [first]="first" [lazy]="true"
        [lazyLoadOnInit]="false" (onLazyLoad)="loadSales($event)" [totalRecords]="totalItems"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
        [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '70rem' }">

        <ng-template #header>
          <tr>
            <th class="px-4 py-2 text-left font-semibold text-base"># Pedido</th>
            <th class="px-4 py-2 text-left font-semibold text-base">Fecha</th>
            <th class="px-4 py-2 text-left font-semibold text-base">Cliente</th>
            <th class="px-4 py-2 text-left font-semibold text-base">Bodega</th>
            <th class="px-4 py-2 text-left font-semibold text-base">Asesor</th>
            <th class="px-4 py-2 text-left font-semibold text-base"># Productos</th>
            <th class="px-4 py-2 text-left font-semibold text-base">Valor Total</th>
            <th class="px-4 py-2 text-left font-semibold text-base">Estado</th>
            <th class="px-4 py-2 text-left font-semibold text-base">Acción</th>
          </tr>
        </ng-template>

        <ng-template #body let-sale>
          <tr class="hover:bg-orange-50">
            <td class="px-6 py-4">{{ sale.orderNumber || sale.id }}</td>
            <td class="px-6 py-4">{{ sale.date | date:'dd/MM/yyyy' }}</td>
            <td class="px-6 py-4">{{ sale.customerName || sale.customerId || '-' }}</td>
            <td class="px-6 py-4">{{ sale.warehouseName || sale.warehouseCode || '-' }}</td>
            <td class="px-6 py-4">{{ sale.accountManagerName || '-' }}</td>
            <td class="px-6 py-4">
              <div class="w-full text-center">
                {{ sale.totalItems ?? 0 }}
              </div>
            </td>
            <td class="px-6 py-4">
              <div class="w-full text-right">
                ${{ (sale.value ?? 0) | number:'1.2-2' }}
              </div>
            </td>
            <td class="px-6 py-4">
              <span class="inline-flex px-3 py-1 text-xs font-medium rounded-xl"
                [ngClass]="getBackgroundClasses(sale.status)">
                {{ getStatusLabel(sale.status) }}
              </span>
            </td>
            <td class="px-6 py-4">
              <div class="text-gray-400 flex flex-row gap-3 items-center">
                <i class="fi fi-rr-eye flex text-2xl text-blue-500 hover:text-blue-700 cursor-pointer"
                  title="Ver detalles" (click)="openOrderDetailDialog(sale)"></i>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    } @else {
    <div class="bg-yellow-100 p-4 rounded-2xl text-yellow-800 flex items-center gap-2">
      <i class="fi-rr-info text-xl"></i>
      <span>Aún no hay registros de ventas para mostrar o los filtros no coinciden.</span>
    </div>
    }
  </div>
</div>
